<template>
  <div class="login">
    <div class="author-top">
      <p>河北《教育实践与研究》杂志社</p>
      <span>作者端</span>
    </div>
    <div class="author-middle">
      <div class="middle-box">
        <p></p>
        <login />
      </div>
    </div>
    <div class="author-bottom"></div>
    <input id="userType" type="hidden" value="1" />
  </div>
</template>
<script>
import Login from './../components/Login';
export default {
  name: 'AuthorLogin',
  components: {
    login: Login
  },
  data() {
    return {};
  },
  methods: {}
};
</script>
<style>
.login {
  width: 100%;
  height: 100vh;
  background-color: #0955d2;
}
.login .author-top {
  width: 100%;
  background: #0955d2;
  text-align: center;
  padding-top: 6%;
}
.login .author-top img {
  margin-top: 2%;
  height: 120px;
  width: 140px;
}
.login .author-top p {
  color: #ffffff;
  font-size: 48px;
  font-family: '微软雅黑';
  margin: 0;
}
.login .author-top span {
  color: #ffffff;
  font-size: 24px;
}
.login .author-middle {
  background: #0955d2;
  width: 100%;
  padding: 40px;
}
.login .author-middle .middle-box {
  width: 420px;
  height: 330px;
  background: #ffffff;
  margin: 0 auto;
  border-radius: 10px;
  text-align: center;
  box-shadow: rgb(199, 196, 196) 18px 20px 10px 0;
}
.login .author-middle .middle-box p {
  font-size: 28px;
  padding-top: 40px;
  font-family: '微软雅黑';
  color: #333333;
}
.login .author-bottom {
  width: 100%;
  background: #0955d2;
  bottom: 0;
}
.login {
  margin: 0;
  padding: 0;
  width: 100%;
}
.author-back {
  width: 100%;
  height: 222px;
  position: absolute;
  background: #1890ff;
  top: 300px;
  left: 0;
}
.login-bod {
  position: absolute;
  left: 39.8%;
  top: 215px;
  width: 355px;
  background: white;
}
.login-top {
  width: 355px;
  height: 11px;
  margin: 0 auto;
}
.login-top img {
  width: 355px;
  height: 11px;
}
.login-out {
  width: 354px;
  margin: 0 auto;
}
.login-div {
  margin: 0;
  padding: 20px;
  width: 354px;
  height: 412px;
  box-shadow: rgb(211, 209, 209) 0px 0px 2px 2px;
}
.ant-input-affix-wrapper .ant-input:not(:first-child) {
  height: 50px;
}
.ant-input-affix-wrapper {
  margin-bottom: 20px;
}
.login-btn {
  width: 100%;
  height: 40px;
  color: white;
  background-color: #1890ff;
  border-color: #1890ff;
  font-size: 18px;
}
.login-title {
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 24px;
  color: #1890ff;
  line-height: 28px;
}
.author-title {
  font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
  font-weight: 700;
  font-style: normal;
  font-size: 16px;
  color: #868686;
  margin-left: 10px;
}
.name {
  margin-bottom: 20px;
  margin-left: 85px;
}
.login-logo {
  margin: 0 auto;
  display: block;
  margin-bottom: 15px;
}
.register {
  float: right;
}
.ant-row {
  margin-bottom: 10px;
}
.title {
  text-align: right;
  margin-top: 5px;
}
.note {
  font-size: 12px;
  color: red;
  margin-top: 5px;
  display: inline-block;
}
.hint {
  font-size: 13px;
  font-weight: bold;
}
.login .author-middle .middle-box .login-com .com-sign {
  font-size: 14px;
  float: right;
  margin-top: 12px;
  margin-right: 16px;
}
.login-com .com-btn .ant-btn-default {
  width: 364px;
  height: 50px;
  background: #005bcd;
  margin-top: 15px;
}
.login-com .com-btn .ant-btn-default span {
  font-size: 18px;
  color: #ffffff;
}
</style>


